export const TagTypes = {
    customer: 'customer',
};

export default {
    TagTypes,
};
